export const blockIconsCommunicationListAlt = (
	<span className='material-symbols-outlined'>list_alt</span>
);
